import request from '@/utils/server'
// 新增
  export function Increase(data) {
    return request({
      url: '/files/upload',
      method: 'POST',
      data: data
    })
  }
//  查询
export function findAllCooker(query) {
  return request({
    url: '/manage/findAllCooker',
    method: 'get',
    params: query
  })
}

  // 删除
  export function deleteCooker(query) {
    return request({
      url: '/manage/deleteCooker',
      method: 'get',
      params: query
    })
  }
  // 名称查询
  export function findCookerByName(query) {
    return request({
      url: '/manage/findCookerByName',
      method: 'get',
      params: query
    })
  }
  // 类型查询
  export function findCookerByType(query) {
    return request({
      url: '/manage/findCookerByType',
      method: 'get',
      params: query
    })
  }

  // 详情
  export function getDishById(query) {
    return request({
      url: '/manage/findCookerById',
      method: 'get',
      params: query
    })
  }
// 首页获取今日菜品
 export function getTodayDish(query) {
    return request({
      url: '/dish/getTodayDish',
      method: 'get',
      params: query
    })
  }
  // 获取打卡人数占比

  export function getClockIn(query) {
    return request({
      url: '/getClockIn',
      method: 'get',
      params: query
    })
  }
  // 设备状态的接口
 
   export function getDevices(query) {
    return request({
      url: '/device/home/getDevices',
      method: 'get',
      params: query
    })
  }
  
   export function addHomePageModels(data) {
    return request({
      url: '/user/addHomePageModels',
        method: 'POST',
      data: data
    })
  }
    export function getHomePageModels(query) {
    return request({
      url: '/user/getHomePageModels',
       method: 'get',
      params: query
    })
  }
  // 删除
 
    export function deleteHomePageModels(data) {
    return request({
      url: '/user/deleteHomePageModels',
     method: 'POST',
      data: data
    })
  }
  // 更改
     export function editHomePageModels(data) {
    return request({
      url: '/user/editHomePageModels',
     method: 'POST',
      data: data
    })
  }